import { useState } from 'react';

// Tipos: 'MOVIMIENTO' | 'GASTO' | 'LIMPIEZA' | 'AJUSTE' | 'TRASPASO' | 'ARQUEO' | 'FONDOS'

export function useModales() {
  const [modal, setModal] = useState(null);

  const abrir = (tipo) => setModal(tipo);
  const cerrar = () => setModal(null);
  const esAbierto = (tipo) => modal === tipo;

  return { modal, abrir, cerrar, esAbierto };
}
